import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
} from 'src/@/components/ui/dialog';

import { Button } from 'src/@/components/ui/button';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { AlertTriangle } from 'lucide-react';

export default function ModalConfimacao({ open, mensagem, erro, onClose, onConfirm, loadingFinalizar }) {

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[480px] p-0 rounded-lg border border-[#E0E0E0] dark:border-[#383838] bg-white dark:bg-[#1A1D21] shadow-[0_18px_50px_-10px_rgba(0,0,0,0.35)] gap-0 [&>button]:top-3 [&>button]:right-3 [&>button]:text-[#616061] [&>button]:hover:text-[#1D1C1D] [&>button]:hover:bg-[#F0F0F0] [&>button]:dark:text-[#ABABAD] [&>button]:dark:hover:text-[#D1D2D3] [&>button]:dark:hover:bg-[#222529] [&>button]:rounded [&>button]:h-7 [&>button]:w-7">
        <div className="px-7 pt-6 pb-4 flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg bg-[#FFF4F4] dark:bg-[#3D1515] flex items-center justify-center flex-shrink-0">
            <AlertTriangle className="w-5 h-5 text-[#D72C0D]" />
          </div>
          <div className="flex-1 pt-1">
            <h2 className="text-[15px] font-bold text-[#1D1C1D] dark:text-[#D1D2D3] mb-1">Confirmar ação</h2>
            <DialogDescription className="text-[13px] text-[#616061] dark:text-[#ABABAD] leading-[1.46668]">
              {mensagem}
            </DialogDescription>
          </div>
        </div>
        {erro && (
          <div className="mx-7 mb-4 px-4 py-3 rounded-lg bg-red-50 dark:bg-[#3D1515] border border-red-200 dark:border-red-900">
            <p className="text-[13px] text-red-700 dark:text-red-400 font-medium">{erro}</p>
          </div>
        )}
        <DialogFooter className="px-7 py-4 border-t border-[#E0E0E0] dark:border-[#383838] bg-[#F8F8F8] dark:bg-[#222529] rounded-b-lg gap-2 sm:gap-2">
          <Button
            variant="ghost"
            onClick={onClose}
            className="text-[13px] font-bold h-9 px-4 rounded text-[#1D1C1D] dark:text-[#D1D2D3] hover:bg-[#E0E0E0] dark:hover:bg-[#383838] border border-[#BBBBBB] dark:border-[#565856] bg-white dark:bg-[#1A1D21] shadow-none transition-colors"
          >
            Cancelar
          </Button>
          <ButtonLoading
            loading={loadingFinalizar}
            onClick={onConfirm}
            autoFocus
            className="text-[13px] font-bold h-9 px-4 rounded bg-[#D72C0D] hover:bg-[#C42B0A] text-white border-0 shadow-none transition-colors"
          >
            Confirmar
          </ButtonLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
